import React, { useState } from 'react';
import {
    EditFilled
} from '@ant-design/icons';
import {
    Button,
    Form,
    Input,
    Modal,
    message
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

export default function EditFormModal({ data }) {
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: ({ values, id }) => {
            axios
                .put(`/api/brand/${id}`, values)
                .then(() => {
                    queryClient.invalidateQueries(['/api/brand/'])
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => setOpen(false)
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({ values, id: data._id }))
    };

    const onCancelCreate = () => {
        setOpen(false);
    }
    return (
        <div>
            {contextHolder}
            <Button
                type='text'
                icon={<EditFilled />}
                style={{ color: '#5f77fc' }}
                onClick={() => setOpen(true)} />
            <Modal
                open={open}
                title="แก้ไขแบรนด์สินค้า"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        ยกเลิก
                    </Button>,
                    <Button key="submit" type="primary" onClick={onCreate}>
                        ตกลง
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name={`edit${data._id}`}
                    initialValues={data}
                >
                    <Form.Item
                        name="name"
                        label="ประเภท"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกข้อมูล',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="description" label="รายละเอียด">
                        <Input type="textarea" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>

    )
}
